import Vue from 'vue';
import ComentoUI from 'comento-ui';
import 'comento-ui/dist/comento-ui.css';

Vue.use(ComentoUI);
